


















import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: 'Guestbook - Send message',
  },
})
export default class GuestbookForm extends Vue {
  message!: string | null

  guestbookContainerClasses =
        'guestbook-write fill-height align-stretch '
        + 'justify-center text-center d-flex flex-column px-1';

  data() {
    return {
      message: null,
    };
  }

  guestbookSubmit = function guestbookSubmit(this: GuestbookForm, e: any) {
    /* eslint-disable no-alert */
    e.preventDefault();

    if (!this.message || (this.message && this.message.trim().length === 0)) {
      alert('This message looks pretty empty');

      return;
    }

    this.axios.post('/api/guestbook/write', {
      message: this.message,
    })
      .then((response) => {
        if (!response.data.success) {
          alert('There was a problem sending the message');
        } else if (response.data.infoMessage) {
          alert(response.data.infoMessage);
        } else {
          alert('Message sent succesfully');
        }
        // Clear form
        this.message = null;
      })
      .catch((error) => {
        alert(error.message);
      });
    /* eslint-enable no-alert */
  }
}
